import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function Callback() {
    const context = useAuth();

    const { idTokenData, logOut, idToken, loginInProgress, login } = context;

    const navigate = useNavigate();

    useEffect(() => {
        if (idToken && idTokenData) {
            try {
                // @ts-expect-error - heap is injected by Heap analytics
                window.heap?.identify(idTokenData?.email);
            } catch (error) {
                console.error(error);
            }
            // Store idTokenData in localStorage
            localStorage.setItem("idTokenData", JSON.stringify(idTokenData));
            navigate("/");
        }
        if (!loginInProgress && !idToken) {
            navigate("/auth");
        }
    }, [idToken, idTokenData, loginInProgress, navigate]);

    if (loginInProgress) {
        return (
            <div>
                <div>Logging in...</div>
            </div>
        );
    }

    if (!idToken) {
        return (
            <div>
                <div>
                    Not logged in. <button onClick={login}>Login</button>
                </div>
                <button
                    onClick={() => {
                        logOut();
                        login();
                    }}
                >
                    Reset
                </button>{" "}
            </div>
        );
    }

    return null;
}
